// Connectivity detection utilities for PWA

export interface DotNetObjectReference {
    invokeMethodAsync(methodName: string, ...args: unknown[]): Promise<unknown>;
}

export function checkOnlineStatus(): boolean {
    return navigator.onLine;
}

export function addOnlineStatusListener(dotNetHelper: DotNetObjectReference): void {
    window.addEventListener('online', () => {
        console.log('App is online');
        dotNetHelper.invokeMethodAsync('OnOnlineStatusChanged', true);
    });

    window.addEventListener('offline', () => {
        console.log('App is offline');
        dotNetHelper.invokeMethodAsync('OnOnlineStatusChanged', false);
    });
}
